import request from "@/api/request";

// 创建/修改自定义风格
async function createOrModifyCustomStyle(data) {
  let {
    diyName,
    styleJson,
    isActive = true,
    jsonName,
    coune = 1,
    pathNavigationSwitchPageId = 0,
  } = data;
  await request.post("/api/PathNavigationSwitch/AddPathNavigationSwitch", {
    diyName,
    styleJson,
    isActive,
    jsonName,
    coune,
    pathNavigationSwitchPageId,
  });
}

// 获取自定义风格
async function getCustomStyle(diyName) {
  const res = await request.post(
    "/api/PathNavigationSwitch/PathNavigationSwitchPageList",
    diyName
  );
  if (!res.data.length) {
    return { id: 0, value: "" };
  }
  return {
    id: res.data[0].pathNavigationSwitchPageId,
    value: res.data[0].styleJson,
  };
}

// 获取表格排序
async function getTableSort(vm, name) {
  const eventName =
    name || localStorage.getItem("server") + vm.$options.name + "TableSort";
  let temp = await getCustomStyle(eventName);
  vm[eventName + "Id"] = temp.id;

  console.log(temp.value,vm.tableSortBy, eventName);

  if (temp.value) {
    let result = JSON.parse(temp.value);
    vm.tableSortBy = result;
    vm.$eventBus.$emit(eventName, result);
  }
}

// 修改表格排序
async function modifyTableSortBy(vm, val, name) {
  const eventName =
    name || localStorage.getItem("server") + vm.$options.name + "TableSort";
  await createOrModifyCustomStyle({
    diyName: eventName,
    styleJson: JSON.stringify(val),
    pathNavigationSwitchPageId: vm[eventName + "Id"],
  });
  if (!vm[eventName + "Id"]) {
    let temp = await getCustomStyle(eventName);
    vm[eventName + "Id"] = temp.id;
  }
}

export {
  createOrModifyCustomStyle,
  getCustomStyle,
  getTableSort,
  modifyTableSortBy,
};
